import React from "react";
import { FlyerDetailPagePreviewLayoutProps } from "./flyer-detail-page-preview-layout.props";
import {
  FlyerDetailPageDetailLayoutGrid,
  HostContainer,
} from "./flyer-detail-page-preview-layout.styles";

export const FlyerDetailPagePreviewLayout = (props: FlyerDetailPagePreviewLayoutProps) => (
  <HostContainer {...props}>
    <FlyerDetailPageDetailLayoutGrid {...props}>{props.children}</FlyerDetailPageDetailLayoutGrid>
  </HostContainer>
);
